<div class="filter-box">
    <h4>YeaR OF PLANTING</h4>

    <div class="form-group" [ngClass]="!!date ? 'added-date' : ''">
        <!--Add class "added-date" to show X button-->
        <input type="text" class="form-control form-control-lg datepicker"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [bsConfig]="bsConf"
            [(ngModel)]="date"
            (ngModelChange)="checkChanged()"
            placeholder="{{placeholder}}"
            readonly
            placement="top"
            bsDatepicker>
        <button class="clear-date" (click)="clear()"><img src="/assets/img/x.svg" /></button>
    </div>
</div>
